export const ADD_GUEST = 'ADD_GUEST';
export const DELETE_GUEST = 'DELETE_GUEST';
export const ADD_HOST = 'ADD_HOST';
export const DELETE_HOST = 'DELETE_HOST';
export const ADD_PRESENTER = 'ADD_PRESENTER';
export const DELETE_PRESENTER = 'DELETE_PRESENTER';
export const CLEAR_MEETING_PANEL_PARTICIPANTS = 'CLEAR_MEETING_PANEL_PARTICIPANTS';
export const TOGGLE_DISABLE_CHAT = 'TOGGLE_DISABLE_CHAT';
export const TOGGLE_DISABLE_REACTIONS = 'TOGGLE_DISABLE_REACTIONS';
export const SET_JWT_PAYLOAD = 'SET_JWT_PAYLOAD';